import { cart } from "@/mixins/iosystems/ShopKit/Cart";
import { order } from "@/mixins/iosystems/ShopKit/Order";

export const shopKit = {
    mixins: [
        cart, order
    ],


};